export function useLanguage() {
  const getAvailableLanguages = () => {
    return [
      { code: "en", name: "English", flag: "uk.png" },
      { code: "th", name: "Thai", flag: "thai.png" },
    ];
  };
  
  const getDefaultLanguage = () => {
    return getAvailableLanguages()[0];
  };

  const getFlagUrl = (flag) => {
    const defaultFlag = require(`@/assets/images/flags/${
      getDefaultLanguage().flag
    }`);
    if (!flag) return defaultFlag;
    if (
      !getAvailableLanguages().some(
        (lang) => lang.flag === flag || `${lang.code}.png` === flag
      )
    )
      return defaultFlag;
    return require(`@/assets/images/flags/${flag}`);
  };

  return {
    getAvailableLanguages,
    getDefaultLanguage,
    getFlagUrl,
  };
}
